export default {
  LOGIN: 'LOGIN',
  FORGET_PASSWORD: 'FORGET_PASSWORD',
  CLEAR_REDUX_STATE: 'CLEAR_REDUX_STATE',
  APP_DATA: 'APP_DATA',
  NO_INTERNET: "NO_INTERNET",
  IS_SKIP:"IS_SKIP",
  IS_FIRST_TIME:"IS_FIRST_TIME"
};
